import Vue from 'vue'
import Router from 'vue-router'
import Frontpage from '@/components/Frontpage'
import Archiv from '@/components/Archiv'
import Archiv2 from '@/components/Archiv2'
import Archiv3 from '@/components/Archiv3'
import Archiv4 from '@/components/Archiv4'
import Archiv5 from '@/components/Archiv5'
import Archiv6 from '@/components/Archiv6'
import Archiv7 from '@/components/Archiv7'
import Veranstaltungen from '@/components/Veranstaltungen'
import Leseraum from '@/components/Leseraum'
import Spiele from '@/components/Spiele'
import Liberoalarm from '@/components/Liberoalarm'
import Spieledownloads from '@/components/Spieledownloads'
import SpieledownloadsDubix from '@/components/Spieledownloads_dubix'
import SpieledownloadsHugi from '@/components/Spieledownloads_hugi'
import SpieledownloadsLibero from '@/components/Spieledownloads_libero'
import SpieledownloadsGigi_01 from '@/components/Spieledownloads_gigi_01'
import SpieledownloadsDubix_01 from '@/components/Spieledownloads_dubix_01'
import SpieledownloadsHugi_01 from '@/components/Spieledownloads_hugi_01'
import SpieledownloadsLibero_01 from '@/components/Spieledownloads_libero_01'
import SpieledownloadsGigi_02 from '@/components/Spieledownloads_gigi_02'
import SpieledownloadsDubix_02 from '@/components/Spieledownloads_dubix_02'
import SpieledownloadsHugi_02 from '@/components/Spieledownloads_hugi_02'
import SpieledownloadsLibero_02 from '@/components/Spieledownloads_libero_02'
import SpieledownloadsGigi_03 from '@/components/Spieledownloads_gigi_03'
import SpieledownloadsDubix_03 from '@/components/Spieledownloads_dubix_03'
import SpieledownloadsHugi_03 from '@/components/Spieledownloads_hugi_03'
import SpieledownloadsLibero_03 from '@/components/Spieledownloads_libero_03'
import SpieledownloadsGigi_04 from '@/components/Spieledownloads_gigi_04'
import SpieledownloadsDubix_04 from '@/components/Spieledownloads_dubix_04'
import SpieledownloadsHugi_04 from '@/components/Spieledownloads_hugi_04'
import SpieledownloadsLibero_04 from '@/components/Spieledownloads_libero_04'
import SpieledownloadsGigi_05 from '@/components/Spieledownloads_gigi_05'
import SpieledownloadsDubix_05 from '@/components/Spieledownloads_dubix_05'
import SpieledownloadsHugi_05 from '@/components/Spieledownloads_hugi_05'
import SpieledownloadsLibero_05 from '@/components/Spieledownloads_libero_05'
import SpieledownloadsGigi_06 from '@/components/Spieledownloads_gigi_06'
import SpieledownloadsDubix_06 from '@/components/Spieledownloads_dubix_06'
import SpieledownloadsHugi_06 from '@/components/Spieledownloads_hugi_06'
import SpieledownloadsLibero_06 from '@/components/Spieledownloads_libero_06'
import SpieledownloadsGigi_07 from '@/components/Spieledownloads_gigi_07'
import SpieledownloadsDubix_07 from '@/components/Spieledownloads_dubix_07'
import SpieledownloadsHugi_07 from '@/components/Spieledownloads_hugi_07'
import SpieledownloadsLibero_07 from '@/components/Spieledownloads_libero_07'
import Spielememory from '@/components/Spielememory'
import SpielememoryMittel from '@/components/Spielememory_mittel'
import SpielememorySchwer from '@/components/Spielememory_schwer'
import Gewinn from '@/components/Gewinn'
import Elterninfo from '@/components/Elterninfo'
import ElterninfoZusatz from '@/components/Elterninfo_zusatz'
import Maerchengeschichten from '@/components/Maerchengeschichten'
import Piratengeschichten from '@/components/Piratengeschichten'
import Zaubergeschichten from '@/components/Zaubergeschichten'
import Skigeschichten from '@/components/Skigeschichten'
import DJgeschichten from '@/components/DJgeschichten'
import Zirkusgeschichten from '@/components/Zirkusgeschichten'
import Junglegeschichten from '@/components/Junglegeschichten'
import Spacegeschichten from '@/components/Spacegeschichten'
import Wassergeschichten from '@/components/Wassergeschichten'
import Ninjageschichten from '@/components/Ninjageschichten'
import Pferdegeschichten from '@/components/Pferdegeschichten'
import Stromgeschichten from '@/components/Stromgeschichten'
import Geschichte_200601 from '@/components/Geschichte_200601'
import Geschichte_200602 from '@/components/Geschichte_200602'
import Geschichte_200603 from '@/components/Geschichte_200603'
import Game from '@/components/Game'
import Olympia from '@/components/Olympia'
import Wal from '@/components/Wal'
import Escaperoom from '@/components/Escaperoom'
import Dinowelt from '@/components/Dinowelt'
import Eiswelt from '@/components/Eiswelt'
import Datenschutz from '@/components/Datenschutz'
import Impressum from '@/components/Impressum'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Frontpage',
      component: Frontpage
    },
    {
      path: '/gewinn',
      name: 'Gewinn',
      component: Gewinn
    },
    {
      path: '/elterninfo',
      name: 'Elterninfo',
      component: Elterninfo
    },
    {
      path: '/elterninfo_zusatz',
      name: 'Elterninfo_zusatz',
      component: ElterninfoZusatz
    },
    {
      path: '/maerchengeschichten',
      name: 'Maerchengeschichten',
      component: Maerchengeschichten
    },
    {
      path: '/piratengeschichten',
      name: 'Piratengeschichten',
      component: Piratengeschichten
    },
    {
      path: '/zaubergeschichten',
      name: 'Zaubergeschichten',
      component: Zaubergeschichten
    },
    {
      path: '/skigeschichten',
      name: 'Skigeschichten',
      component: Skigeschichten
    },
    {
      path: '/djgeschichten',
      name: 'DJgeschichten',
      component: DJgeschichten
    },
    {
      path: '/zirkusgeschichten',
      name: 'Zirkusgeschichten',
      component: Zirkusgeschichten
    },
    {
      path: '/junglegeschichten',
      name: 'Junglegeschichten',
      component: Junglegeschichten
    },
    {
      path: '/spacegeschichten',
      name: 'Spacegeschichten',
      component: Spacegeschichten
    },
    {
      path: '/wassergeschichten',
      name: 'Wassergeschichten',
      component: Wassergeschichten
    },
    {
      path: '/stromgeschichten',
      name: 'Stromgeschichten',
      component: Stromgeschichten
    },
    {
      path: '/ninjageschichten',
      name: 'Ninjageschichten',
      component: Ninjageschichten
    },
    {
      path: '/pferdegeschichten',
      name: 'Pferdegeschichten',
      component: Pferdegeschichten
    },
    {
      path: '/geschichte_200601',
      name: 'Geschichte_200601',
      component: Geschichte_200601
    },
    {
      path: '/geschichte_200602',
      name: 'Geschichte_200602',
      component: Geschichte_200602
    },
    {
      path: '/geschichte_200603',
      name: 'Geschichte_200603',
      component: Geschichte_200603
    },
      {
      path: '/game',
      name: 'Game',
      component: Game
    },
    {
      path: '/olympia',
      name: 'Olympia',
      component: Olympia
    },
    {
      path: '/wal',
      name: 'Wal',
      component: Wal
    },
    {
      path: '/escaperoom',
      name: 'Escaperoom',
      component: Escaperoom
    },
    {
      path: '/dinowelt',
      name: 'Dinowelt',
      component: Dinowelt
    },
    {
      path: '/eiswelt',
      name: 'Eiswelt',
      component: Eiswelt
    },
    {
      path: '/archiv',
      name: 'Archiv',
      component: Archiv
    },
    {
      path: '/archiv2',
      name: 'Archiv2',
      component: Archiv2
    },
    {
      path: '/archiv3',
      name: 'Archiv3',
      component: Archiv3
    },
    {
      path: '/archiv4',
      name: 'Archiv4',
      component: Archiv4
    },
    {
      path: '/archiv5',
      name: 'Archiv5',
      component: Archiv5
    },
    {
      path: '/archiv6',
      name: 'Archiv6',
      component: Archiv6
    },
    {
      path: '/archiv7',
      name: 'Archiv7',
      component: Archiv7
    },
    {
      path: '/Leseraum',
      name: 'Leseraum',
      component: Leseraum
    },
    {
      path: '/liberoalarm',
      name: 'Liberoalarm',
      component: Liberoalarm
    },
    {
      path: '/spiele',
      name: 'Spiele',
      component: Spiele
    },
    {
      path: '/spieledownloads',
      name: 'Spieledownloads',
      component: Spieledownloads
    },
    {
      path: '/spieledownloads_dubix',
      name: 'Spieledownloads_dubix',
      component: SpieledownloadsDubix
    },
    {
      path: '/spieledownloads_hugi',
      name: 'Spieledownloads_hugi',
      component: SpieledownloadsHugi
    },
    {
      path: '/spieledownloads_libero',
      name: 'Spieledownloads_libero',
      component: SpieledownloadsLibero
    },
    {
      path: '/spieledownloads_gigi_01',
      name: 'Spieledownloads_gigi_01',
      component: SpieledownloadsGigi_01
    },
    {
      path: '/spieledownloads_dubix_01',
      name: 'Spieledownloads_dubix_01',
      component: SpieledownloadsDubix_01
    },
    {
      path: '/spieledownloads_hugi_01',
      name: 'Spieledownloads_hugi_01',
      component: SpieledownloadsHugi_01
    },
    {
      path: '/spieledownloads_libero_01',
      name: 'Spieledownloads_libero_01',
      component: SpieledownloadsLibero_01
    },
    {
      path: '/spieledownloads_gigi_02',
      name: 'Spieledownloads_gigi_02',
      component: SpieledownloadsGigi_02
    },
    {
      path: '/spieledownloads_dubix_02',
      name: 'Spieledownloads_dubix_02',
      component: SpieledownloadsDubix_02
    },
    {
      path: '/spieledownloads_hugi_02',
      name: 'Spieledownloads_hugi_02',
      component: SpieledownloadsHugi_02
    },
    {
      path: '/spieledownloads_libero_02',
      name: 'Spieledownloads_libero_02',
      component: SpieledownloadsLibero_02
    },
    {
      path: '/spieledownloads_gigi_03',
      name: 'Spieledownloads_gigi_03',
      component: SpieledownloadsGigi_03
    },
    {
      path: '/spieledownloads_dubix_03',
      name: 'Spieledownloads_dubix_03',
      component: SpieledownloadsDubix_03
    },
    {
      path: '/spieledownloads_hugi_03',
      name: 'Spieledownloads_hugi_03',
      component: SpieledownloadsHugi_03
    },
    {
      path: '/spieledownloads_libero_03',
      name: 'Spieledownloads_libero_03',
      component: SpieledownloadsLibero_03
    },
    {
      path: '/spieledownloads_gigi_04',
      name: 'Spieledownloads_gigi_04',
      component: SpieledownloadsGigi_04
    },
    {
      path: '/spieledownloads_dubix_04',
      name: 'Spieledownloads_dubix_04',
      component: SpieledownloadsDubix_04
    },
    {
      path: '/spieledownloads_hugi_04',
      name: 'Spieledownloads_hugi_04',
      component: SpieledownloadsHugi_04
    },
    {
      path: '/spieledownloads_libero_04',
      name: 'Spieledownloads_libero_04',
      component: SpieledownloadsLibero_04
    },
    {
      path: '/spieledownloads_gigi_05',
      name: 'Spieledownloads_gigi_05',
      component: SpieledownloadsGigi_05
    },
    {
      path: '/spieledownloads_dubix_05',
      name: 'Spieledownloads_dubix_05',
      component: SpieledownloadsDubix_05
    },
    {
      path: '/spieledownloads_hugi_05',
      name: 'Spieledownloads_hugi_05',
      component: SpieledownloadsHugi_05
    },
    {
      path: '/spieledownloads_libero_05',
      name: 'Spieledownloads_libero_05',
      component: SpieledownloadsLibero_05
    },
    {
      path: '/spieledownloads_gigi_06',
      name: 'Spieledownloads_gigi_06',
      component: SpieledownloadsGigi_06
    },
    {
      path: '/spieledownloads_dubix_06',
      name: 'Spieledownloads_dubix_06',
      component: SpieledownloadsDubix_06
    },
    {
      path: '/spieledownloads_hugi_06',
      name: 'Spieledownloads_hugi_06',
      component: SpieledownloadsHugi_06
    },
    {
      path: '/spieledownloads_libero_06',
      name: 'Spieledownloads_libero_06',
      component: SpieledownloadsLibero_06
    },
      {
      path: '/spieledownloads_gigi_07',
      name: 'Spieledownloads_gigi_07',
      component: SpieledownloadsGigi_07
    },
    {
      path: '/spieledownloads_dubix_07',
      name: 'Spieledownloads_dubix_07',
      component: SpieledownloadsDubix_07
    },
    {
      path: '/spieledownloads_hugi_07',
      name: 'Spieledownloads_hugi_07',
      component: SpieledownloadsHugi_07
    },
    {
      path: '/spieledownloads_libero_07',
      name: 'Spieledownloads_libero_07',
      component: SpieledownloadsLibero_07
    },
    {
      path: '/spielememory',
      name: 'Spielememory',
      component: Spielememory
    },
    {
      path: '/spielememory_mittel',
      name: 'Spielememory_mittel',
      component: SpielememoryMittel
    },
    {
      path: '/spielememory_schwer',
      name: 'Spielememory_schwer',
      component: SpielememorySchwer
    },
    {
      path: '/veranstaltungen',
      name: 'Veranstaltungen',
      component: Veranstaltungen
    },
    {
      path: '/datenschutz',
      name: 'Datenschutz',
      component: Datenschutz
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: Impressum
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js